import Constant from '@/const';
import axios from 'axios';

const getCategoryByMenu = async () => {
  try {
    const response = await axios.get(
      Constant.apiUrl.concat('/master/category/menu/Farmasi'),
    );
    return response;
  } catch (error) {
    this.showErrorAxios(error);
  }
};

export default getCategoryByMenu;
